import { DefaultButton, TextField } from '@fluentui/react';
import { textFieldStyles } from '../../../../common/views/DefaultStyles';
import { Utils } from '../../../../common/views/Utils';
import { OrderModel, EditOrderModel } from '../../../models/OrderModel';

type EditOrderPriceProps = {
    order: OrderModel;
    form: EditOrderModel;
    loading: boolean;
    setShowPicture: (value: boolean) => void;
    onValueChange: (field: keyof EditOrderModel, value: any) => void;
    onSubmit: () => void;
}

export default function EditOrderPriceView({
    form, loading, setShowPicture, onValueChange, onSubmit
}: EditOrderPriceProps) {
    const width3 = Utils.getColumnWidth(3);
    const amount = form.price * form.qty * (100 + form.rate) / 100;
    const total = amount + form.domesticShipping + (form.shippingRate * form.chargeWeight);

    const priceInput = () => {
        return <>
            <TextField
                label="Price"
                value={form.price.toString()}
                styles={textFieldStyles}
                onChange={(_, v) => onValueChange("price", v || 0)} />
        </>;
    }

    const qtyInput = () => {
        return <>
            <TextField
                label="Qty"
                value={form.qty.toString()}
                styles={textFieldStyles}
                onChange={(_, v) => onValueChange("qty", v || 0)} />
        </>;
    }

    const rateInput = () => {
        return <>
            <TextField
                label="Rate"
                value={form.rate.toString()}
                styles={textFieldStyles}
                onChange={(_, v) => onValueChange("rate", v || 0)} />
        </>;
    }

    const amountInput = () => {
        return <>
            <TextField
                label="Amount"
                value={amount.toFixed(2)}
                styles={textFieldStyles}
                readOnly={true} />
        </>;
    }

    const shipUsInput = () => {
        return <>
            <TextField
                label="Ship in US"
                value={form.domesticShipping.toString()}
                styles={textFieldStyles}
                onChange={(_, v) => onValueChange("domesticShipping", v || 0)} />
        </>;
    }

    const shipRateInput = () => {
        return <>
            <TextField
                label="Ship Rate"
                value={form.shippingRate.toString()}
                styles={textFieldStyles}
                onChange={(_, v) => onValueChange("shippingRate", v || 0)} />
        </>;
    }

    const weightInput = () => {
        return <>
            <TextField
                label="Weight"
                value={form.chargeWeight.toString()}
                styles={textFieldStyles}
                onChange={(_, v) => onValueChange("chargeWeight", v || 0)} />
        </>;
    }

    const totalInput = () => {
        return <>
            <TextField
                label="Total"
                value={total.toFixed(2)}
                styles={textFieldStyles}
                readOnly={true} />
        </>;
    }

    const inputForm = () => {
        return <>
            <div className="ms-Grid-row">
                <div className={width3}>{priceInput()}</div>
                <div className={width3}>{qtyInput()}</div>
                <div className={width3}>{rateInput()}</div>
                <div className={width3}>{amountInput()}</div>
            </div>

            <div className="ms-Grid-row pt-10">
                <div className={width3}>{shipUsInput()}</div>
                <div className={width3}>{shipRateInput()}</div>
                <div className={width3}>{weightInput()}</div>
                <div className={width3}>{totalInput()}</div>
            </div>
        </>
    }

    return <>
        {inputForm()}

        {!loading && <div className="pt-15 right">
            <DefaultButton onClick={onSubmit}>Save Change</DefaultButton>
        </div>}
    </>;
}